import { render, staticRenderFns } from "./childWorks.vue?vue&type=template&id=760923f4&"
import script from "./childWorks.vue?vue&type=script&lang=js&"
export * from "./childWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports